import { render, staticRenderFns } from "./ConceptsList.vue?vue&type=template&id=2dcb3bbe"
import script from "./ConceptsList.vue?vue&type=script&lang=js"
export * from "./ConceptsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports